import type { Address } from '@wiko/addresses';
import { isWikoError, WIKO_ERROR__INSTRUCTION_ERROR__CUSTOM, WikoError } from '@wiko/errors';

export function isProgramError<TProgramErrorCode extends number>(
    error: unknown,
    transactionMessage: { instructions: Record<number, { programAddress: Address }> },
    programAddress: Address,
    code?: TProgramErrorCode,
): error is Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> &
    WikoError<typeof WIKO_ERROR__INSTRUCTION_ERROR__CUSTOM> {
    if (!isWikoError(error, WIKO_ERROR__INSTRUCTION_ERROR__CUSTOM)) {
        return false;
    }
    const instructionProgramAddress = transactionMessage.instructions[error.context.index]?.programAddress;
    if (!instructionProgramAddress || instructionProgramAddress !== programAddress) {
        return false;
    }
    return typeof code === 'undefined' || error.context.code === code;
}
